module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p14",
      "title": "14"
    }
  }, [_c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "monkey_bread"
    }
  }, [_vm._v("Monkey Bread")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("16 servings")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 35 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 3 Hours 25 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3½")]), _vm._v(" to 4 cups all-purpose flour")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("⅓")]), _vm._v(" cup sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" package regular active or fast-acting dry yeast (2¼ teaspoons)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup water")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("⅓")]), _vm._v(" cup butter, softened")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" egg")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¾")]), _vm._v(" cup sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup finely chopped nuts")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup butter, melted")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" In large bowl, stir 2 cups of the flour, ⅓ cup sugar, the salt and yeast with wooden spoon until well mixed. In 1-quart saucepan, heat water and ⅓ cup butter over medium-low heat, stirring frequently, until very warm and an instant-read thermometer reads 120°F to 130°F. Add water mixture and egg to flour mixture. Beat with whisk or electric mixer on low speed 1 minute, stopping frequently to scrape batter from side and bottom of bowl with rubber spatula, until smooth. Beat on medium speed 1 minute, stopping frequently to scrape bowl. With wooden spoon, stir in enough of the remaining flour, 1 cup at a time, until dough is soft, leaves side of bowl and is easy to handle (dough may be slightly sticky).")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Place dough on lightly floured surface. Knead about 10 minutes, sprinkling surface with more flour if dough starts to stick, until dough is smooth and springy.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" Spray large bowl with cooking spray. Place dough in bowl, turning dough to grease all sides. Cover bowl loosely with plastic wrap; let rise in warm place 1 hour to 1 hour 30 minutes or until dough has doubled in size. Dough is ready if indentation remains when touched.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("4")]), _vm._v(" Spray 10-inch angel food (tube) cake pan or 12-cup fluted tube cake pan with baking spray with flour. (If angel food cake pan has removable bottom, line pan with foil before spraying to help prevent the sugar mixture from dripping in the oven during baking.) In small bowl, mix ¾ cup sugar, the nuts and cinnamon.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("5")]), _vm._v(" Gently push fist into dough to deflate. Shape dough into about 25 (1½-inch) balls. Dip each ball into melted butter, then into sugar mixture. Place single layer of balls in pan so they just touch. Top with another layer of balls. Cover pan loosely with plastic wrap; let rise in warm place about 40 minutes or until dough has doubled in size.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("6")]), _vm._v(" Move oven rack to low position so top of pan will be in center of oven. Heat oven to 375°F. Uncover bread. Bake 35 to 40 minutes or until golden brown. (If bread browns too quickly, cover loosely with foil.) Run metal spatula or knife around edge of pan to loosen bread. Place heatproof serving plate upside down on pan; holding plate and pan with pot holders, turn plate and pan over together. Let stand 1 minute so butter-sugar mixture can drizzle over bread; remove pan. Serve bread warm, pulling it apart using 2 forks or your fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("7")]), _vm._v(" To freeze, cool completely. Wrap tightly (the whole loaf, or divide into halves or quarters). Freeze up to 3 months. Thaw at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 270; Total Fat 13g (Saturated Fat 6g, Trans Fat 0g); Cholesterol 40mg; Sodium 220mg; Total Carbohydrate 35g (Dietary Fiber 1g); Protein 4g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" 1 Starch, 1½ Other Carbohydrate, 2½ Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 2")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p15",
      "title": "15"
    }
  }, [_c('figure', {
    staticClass: "figure1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/p015.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p014"
    }
  }, [_vm._v("Monkey Bread")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0424076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p014.vue
// module id = 93
// module chunks = 0